/*
 * Public API Surface of ngx-lib/internal-button
 */
export * from './internal-button.module';
export * from './internal-button.component';
